import React from 'react';

import { Card, Content, Price, Title, Subtitle } from 'components/Cards/DataCardAuto/styles';
import Shimmer from 'components/Shimmer';
import withGrid from 'hocs/withGrid';
const LoadingCard = () => (
  <Card>
    <Card.Image>
      <Card.Logo></Card.Logo>
      <Card.Photo></Card.Photo>
    </Card.Image>
    <Content>
      <Title>
        <Shimmer>Vehicle Model Name</Shimmer>
      </Title>
      <Subtitle>
        <Shimmer>Category</Shimmer>
      </Subtitle>
      <Card.AutoInfo>
        <Shimmer width="20px" height="20px"></Shimmer>
        <Shimmer width="20px" height="20px"></Shimmer>
        <Shimmer width="20px" height="20px"></Shimmer>
        <Shimmer>Manual</Shimmer>
        <Shimmer>KM Ilimitado</Shimmer>
      </Card.AutoInfo>
      <Price>
        <Price.Total>
          <Shimmer>$999.999 COP</Shimmer>
        </Price.Total>
        <Price.Info>
          <Shimmer>Precio final por 2 días</Shimmer>
        </Price.Info>
        <Price.Policy>
          <Shimmer>Dentro de política</Shimmer>
        </Price.Policy>
      </Price>
    </Content>
  </Card>
);

export default withGrid(LoadingCard);
